import React, { FC, useCallback } from 'react';
import MenuTriggerContentWithIcon from '../../../menuTriggerContentWithIcon';
import { googleClickCtaEvent } from '../../../../../../utils/analytics';
import RoutableSitecoreLink from '../../../../../@shared/routableSitecoreLink';

const DesktopLogin: FC<{ fields: any }> = ({ fields }) => {
  const handleClick = useCallback(() => {
    googleClickCtaEvent(
      'Global Nav',
      fields?.login?.link?.value?.text,
      fields?.login?.link?.value?.text
    );
  }, []);

  return (
    <li className="navigation__menu-item">
      <RoutableSitecoreLink
        field={fields?.login?.link}
        onClick={handleClick}
        target="_blank"
        className="navigation__menu-item__trigger"
      >
        <MenuTriggerContentWithIcon
          iconField={fields?.login?.icon}
          textValue={fields?.login?.link?.value?.text}
        />
      </RoutableSitecoreLink>
    </li>
  );
};

export default DesktopLogin;
